var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageExists)?_c('md-avatar',{staticClass:"md-avatar-icon"},[_c('img',{attrs:{"src":_vm.finalUrl,"alt":"User avatar"},on:{"error":_vm.imageLoadError}})]):_c('md-avatar',{staticClass:"md-avatar-icon"},[_vm._v(_vm._s(_vm.finalUserName[0]))])
}
var staticRenderFns = []

export { render, staticRenderFns }